
import { motion } from 'framer-motion';
import { useInView } from '../../../hooks/useInView';

export default function EUProjectInfo() {
  const { ref, isInView } = useInView(0.1);

  return (
    <section ref={ref} className="py-10 sm:py-16 bg-[#0a0a0a]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          {/* Header */}
          <div className="text-center mb-8 sm:mb-12">
            <h2
              className="text-white text-xl sm:text-2xl md:text-3xl font-bold mb-3 sm:mb-4"
              style={{ fontFamily: 'Orbitron, sans-serif' }}
            >
              Informacje o <span className="text-[#00E5FF]">Projekcie</span>
            </h2>
            <div className="w-12 sm:w-16 h-1 bg-[#00E5FF] mx-auto"></div>
          </div>

          {/* Card */}
          <div className="bg-[#111111] border border-[#1a1a1a] rounded-lg overflow-hidden">
            {/* Card header */}
            <div className="bg-gradient-to-r from-[#003399] via-[#003399]/80 to-[#003399] px-4 sm:px-8 py-3 sm:py-4">
              <div className="flex items-center gap-2 sm:gap-3">
                <div className="w-7 h-7 sm:w-8 sm:h-8 flex items-center justify-center rounded-full bg-[#FFD700]/20">
                  <i className="ri-file-list-3-line text-[#FFD700] text-xs sm:text-sm"></i>
                </div>
                <span
                  className="text-white text-[10px] sm:text-sm font-semibold tracking-wide"
                  style={{ fontFamily: 'Orbitron, sans-serif' }}
                >
                  PROJEKT DOFINANSOWANY Z UE
                </span>
              </div>
            </div>

            {/* Card body */}
            <div className="p-4 sm:p-6 md:p-8 lg:p-10">
              <h3
                className="text-white text-base sm:text-xl md:text-2xl font-bold mb-5 sm:mb-8 leading-relaxed"
                style={{ fontFamily: 'Inter, sans-serif' }}
              >
                &ldquo;Wdrożenie innowacyjnych technologii spawalniczych i obróbki
                metali w Przedsiębiorstwie Wielobranżowym EUREKA&rdquo;
              </h3>

              {/* Project details grid */}
              <div className="grid sm:grid-cols-2 gap-4 sm:gap-6 mb-6 sm:mb-10">
                {/* Left column */}
                <div className="space-y-4 sm:space-y-5">
                  {/* Numer projektu */}
                  <div className="flex items-start gap-3 sm:gap-4">
                    <div className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center rounded-lg bg-[#003399]/15 flex-shrink-0 mt-0.5">
                      <i className="ri-hashtag text-[#00E5FF] text-base sm:text-lg"></i>
                    </div>
                    <div>
                      <span
                        className="text-[#888] text-[10px] sm:text-xs uppercase tracking-wider block mb-1"
                        style={{ fontFamily: 'Inter, sans-serif' }}
                      >
                        Numer projektu
                      </span>
                      <span
                        className="text-white text-xs sm:text-sm font-medium"
                        style={{ fontFamily: 'Inter, sans-serif' }}
                      >
                        FENG.01.01-IP.01-0XXX/XX
                      </span>
                    </div>
                  </div>

                  {/* Okres realizacji */}
                  <div className="flex items-start gap-3 sm:gap-4">
                    <div className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center rounded-lg bg-[#003399]/15 flex-shrink-0 mt-0.5">
                      <i className="ri-calendar-line text-[#00E5FF] text-base sm:text-lg"></i>
                    </div>
                    <div>
                      <span
                        className="text-[#888] text-[10px] sm:text-xs uppercase tracking-wider block mb-1"
                        style={{ fontFamily: 'Inter, sans-serif' }}
                      >
                        Okres realizacji
                      </span>
                      <span
                        className="text-white text-xs sm:text-sm font-medium"
                        style={{ fontFamily: 'Inter, sans-serif' }}
                      >
                        01.01.2024 – 31.12.2025
                      </span>
                    </div>
                  </div>

                  {/* Miejsce realizacji */}
                  <div className="flex items-start gap-3 sm:gap-4">
                    <div className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center rounded-lg bg-[#003399]/15 flex-shrink-0 mt-0.5">
                      <i className="ri-map-pin-line text-[#00E5FF] text-base sm:text-lg"></i>
                    </div>
                    <div>
                      <span
                        className="text-[#888] text-[10px] sm:text-xs uppercase tracking-wider block mb-1"
                        style={{ fontFamily: 'Inter, sans-serif' }}
                      >
                        Miejsce realizacji
                      </span>
                      <span
                        className="text-white text-xs sm:text-sm font-medium"
                        style={{ fontFamily: 'Inter, sans-serif' }}
                      >
                        Zabłotce 146, 38-500 Sanok
                      </span>
                    </div>
                  </div>
                </div>

                {/* Right column */}
                <div className="space-y-4 sm:space-y-5">
                  {/* Wartość projektu */}
                  <div className="flex items-start gap-3 sm:gap-4">
                    <div className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center rounded-lg bg-[#FFD700]/10 flex-shrink-0 mt-0.5">
                      <i className="ri-money-euro-circle-line text-[#FFD700] text-base sm:text-lg"></i>
                    </div>
                    <div>
                      <span
                        className="text-[#888] text-[10px] sm:text-xs uppercase tracking-wider block mb-1"
                        style={{ fontFamily: 'Inter, sans-serif' }}
                      >
                        Wartość projektu
                      </span>
                      <span
                        className="text-white text-xs sm:text-sm font-medium"
                        style={{ fontFamily: 'Inter, sans-serif' }}
                      >
                        2 500 000,00 PLN
                      </span>
                    </div>
                  </div>

                  {/* Kwota dofinansowania */}
                  <div className="flex items-start gap-3 sm:gap-4">
                    <div className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center rounded-lg bg-[#FFD700]/10 flex-shrink-0 mt-0.5">
                      <i className="ri-hand-coin-line text-[#FFD700] text-base sm:text-lg"></i>
                    </div>
                    <div>
                      <span
                        className="text-[#888] text-[10px] sm:text-xs uppercase tracking-wider block mb-1"
                        style={{ fontFamily: 'Inter, sans-serif' }}
                      >
                        Kwota dofinansowania
                      </span>
                      <span
                        className="text-white text-xs sm:text-sm font-medium"
                        style={{ fontFamily: 'Inter, sans-serif' }}
                      >
                        1 500 000,00 PLN
                      </span>
                    </div>
                  </div>

                  {/* Beneficjent */}
                  <div className="flex items-start gap-3 sm:gap-4">
                    <div className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center rounded-lg bg-[#FFD700]/10 flex-shrink-0 mt-0.5">
                      <i className="ri-building-line text-[#FFD700] text-base sm:text-lg"></i>
                    </div>
                    <div>
                      <span
                        className="text-[#888] text-[10px] sm:text-xs uppercase tracking-wider block mb-1"
                        style={{ fontFamily: 'Inter, sans-serif' }}
                      >
                        Beneficjent
                      </span>
                      <span
                        className="text-white text-xs sm:text-sm font-medium"
                        style={{ fontFamily: 'Inter, sans-serif' }}
                      >
                        P.W. EUREKA Janusz Gładysz
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Cel projektu */}
              <div className="bg-[#0a0a0a] border border-[#1a1a1a] rounded-lg p-4 sm:p-6 mb-4 sm:mb-8">
                <div className="flex items-center gap-2 sm:gap-3 mb-3 sm:mb-4">
                  <div className="w-7 h-7 sm:w-8 sm:h-8 flex items-center justify-center rounded-lg bg-[#00E5FF]/10">
                    <i className="ri-focus-3-line text-[#00E5FF] text-sm sm:text-base"></i>
                  </div>
                  <h4
                    className="text-white text-sm sm:text-base font-bold"
                    style={{ fontFamily: 'Orbitron, sans-serif' }}
                  >
                    <a
                      href="#cel-projektu"
                      className="hover:text-[#00E5FF] transition-colors cursor-pointer"
                    >
                      Cel projektu
                    </a>
                  </h4>
                </div>
                <p
                  className="text-[#C0C7CF] text-xs sm:text-sm leading-relaxed"
                  style={{ fontFamily: 'Inter, sans-serif' }}
                >
                  Celem projektu jest zwiększenie konkurencyjności przedsiębiorstwa
                  poprzez wdrożenie innowacyjnych technologii spawalniczych oraz
                  nowoczesnych metod obróbki metali. Realizacja projektu pozwoli na
                  poszerzenie oferty o zaawansowane konstrukcje stalowe i mostowe,
                  zwiększenie mocy produkcyjnych oraz poprawę jakości wytwarzanych
                  produktów zgodnie z najwyższymi normami europejskimi.
                </p>
              </div>

              {/* Planowane efekty */}
              <div className="bg-[#0a0a0a] border border-[#1a1a1a] rounded-lg p-4 sm:p-6">
                <div className="flex items-center gap-2 sm:gap-3 mb-3 sm:mb-4">
                  <div className="w-7 h-7 sm:w-8 sm:h-8 flex items-center justify-center rounded-lg bg-[#00E5FF]/10">
                    <i className="ri-bar-chart-box-line text-[#00E5FF] text-sm sm:text-base"></i>
                  </div>
                  <h4
                    className="text-white text-sm sm:text-base font-bold"
                    style={{ fontFamily: 'Orbitron, sans-serif' }}
                  >
                    <a
                      href="#planowane-efekty"
                      className="hover:text-[#00E5FF] transition-colors cursor-pointer"
                    >
                      Planowane efekty
                    </a>
                  </h4>
                </div>

                <div className="grid grid-cols-3 gap-2 sm:gap-4">
                  {[
                    { icon: 'ri-tools-line', label: 'Nowe stanowiska spawalnicze', value: '4' },
                    { icon: 'ri-team-line', label: 'Nowe miejsca pracy', value: '8' },
                    { icon: 'ri-arrow-up-circle-line', label: 'Wzrost wydajności', value: '35%' },
                  ].map((item, i) => (
                    <div
                      key={i}
                      className="text-center p-3 sm:p-4 bg-[#111111] rounded-lg"
                    >
                      <div className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center mx-auto mb-2 sm:mb-3 rounded-full bg-[#00E5FF]/10">
                        <i
                          className={`${item.icon} text-[#00E5FF] text-sm sm:text-lg`}
                        ></i>
                      </div>
                      <span
                        className="text-[#00E5FF] text-lg sm:text-2xl font-bold block mb-0.5 sm:mb-1"
                        style={{ fontFamily: 'Orbitron, sans-serif' }}
                      >
                        {item.value}
                      </span>
                      <span
                        className="text-[#888] text-[9px] sm:text-xs leading-tight block"
                        style={{ fontFamily: 'Inter, sans-serif' }}
                      >
                        {item.label}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
